module.exports = __webpack_public_path__ + "static/img/identity_card.f42ddd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identity_card.png
// module id = 1397
// module chunks = 1